import React from "react";
import { motion } from "framer-motion";
import {
  ShieldCheck,
  Users,
  Search,
  Target,
  Lock,
} from "lucide-react";

const trustMetrics = [
  {
    icon: Target,
    title: "We research before we build",
  },
  {
    icon: Users,
    title: "We focus on clarity and performance",
  },
  {
    icon: Search,
    title: "We build with SEO in mind from day one",
  },
  {
    icon: ShieldCheck,
    title: "We create solutions that support real business use",
  },
  {
    icon: Lock,
    title: "We stay involved after launch",
  },
];

export const TrustSection = () => {
  return (
    <section className="section-padding-sm bg-gradient-to-b from-muted/50 to-background relative overflow-hidden">
      {/* soft background */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-24 left-10 w-72 h-72 bg-primary/10 rounded-full blur-3xl opacity-60" />
        <div className="absolute -bottom-24 right-10 w-80 h-80 bg-secondary/10 rounded-full blur-3xl opacity-60" />
      </div>

      <div className="container-custom relative z-10">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto mb-10 sm:mb-14"
        >
          <span className="text-sm font-medium text-primary uppercase tracking-wider">
            Why Choose Us
          </span>

          <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground mt-3 mb-5">
            We Build Around the Business, Not Around a{" "}
            <span className="gradient-text">Template</span>
          </h2>

          <p className="text-muted-foreground leading-relaxed">
            Our work is guided by strategy, practical thinking, and a clear
            understanding of what the business needs to achieve online.
          </p>
        </motion.div>

        {/* Metrics grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 sm:gap-6">
          {trustMetrics.map((m, index) => {
            const Icon = m.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.06 }}
                whileHover={{ y: -4 }}
                className="h-full p-5 sm:p-6 rounded-2xl bg-card border border-border hover:border-primary/30 hover:shadow-medium transition-all duration-300 flex flex-col items-center text-center sm:items-start sm:text-left"
              >
                <div className="w-12 h-12 rounded-xl gradient-primary-soft flex items-center justify-center mb-4 mx-auto sm:mx-0">
                  <Icon className="h-6 w-6 text-primary" />
                </div>

                <h3 className="font-display font-semibold text-foreground">
  {m.title}
</h3>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};